(ns frontend.ui.component.lp-portal.report.body.sparkmind.fund.web
  (:require
   [common.util :as cu]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.report.component.block-table.view :as block-table]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.view :as horizontal-table]
   [frontend.ui.component.lp-portal.report.component.vertical-table.view :as vertical-table]
   [frontend.ui.component.lp-portal.voima-components.chart-card.chart-card :as chart-card]
   [frontend.ui.component.lp-portal.voima-components.free-text-card.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.voima-components.section.view :as section]
   [frontend.ui.component.lp-portal.voima-components.text-content.view :as text-content]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.component.lp-portal.voima-components.card.view :refer [card]]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.fund-overview :refer [empty-table-data?]]
   [frontend.ui.component.lp-portal.report.body.voima.fund.web :refer [subheading]]))

(defn fund-overview-section
  [{:keys [fund-overview-1 fund-overview-2 executive-summary-figures case-overview]} props]
  (let [block-table-config {:border?        false
                            :hide-footnote? true}]
    [section/section "Fund overview"
     (str "fund-overview-"
          (some->> props
                   :report
                   :db/id))
     [card {:title ""}
      [grid/row {}
       [grid/column {:large 6}
        [block-table/table "" fund-overview-2 (merge props block-table-config)]]
       [grid/column {:large 6}
        [block-table/table "" fund-overview-1 (merge props block-table-config)]]]]
     [card {:title "Executive summary"}
      [free-text-card/free-text-section "" case-overview props]]]))

(defn fund-status-section
  [{:keys [fund-value-bridge value-progression
           net-asset-value
           key-metrics]
    :as   data} props]
  (let [empty-waterfall? (->> fund-value-bridge
                              :figures
                              :series
                              (first)
                              :data
                              (filter (fn [data]
                                        (not (cu/blank-value? (:y data)))))
                              (count)
                              (= 0))]
    [section/section ""
     (str "fund-overview-"
          (some->> props
                   :report
                   :db/id))
     [:div
      [chart-card/view "Value progression (EUR)" value-progression props]
      [chart-card/view "Fund value bridge (EUR)" fund-value-bridge
       (merge props {:removed-since-empty? empty-waterfall?})]
      (when-not (and (empty-table-data? data :net-asset-value)
                     (empty-table-data? data :key-metrics))
        [subheading "Fund performance status"])
      [horizontal-table/table "" net-asset-value props]
      [vertical-table/table "" key-metrics props]]]))

(defn portfolio-information-section
  [{:keys [portfolio-summary change-in-fair-value] :as portfolio-information} props]
  (let [hide-section? (and (empty-table-data? portfolio-information :portfolio-summary)
                           (empty-table-data? portfolio-information :change-in-fair-value)
                           (not (:edit-mode? props)))]
    (when-not hide-section?
      [section/section "Portfolio information"
       (str "portfolio-information-"
            (some->> props
                     :report
                     :db/id))
       [:div
        [horizontal-table/table "Portfolio summary" portfolio-summary props]
        [horizontal-table/table "Change in fair value" change-in-fair-value props]]])))

(defn investor-information-section
  [{:keys [capital-account-year-to-date capital-account-since-inception] :as investor-information} props]
  (let [hide-section? (and (empty-table-data? investor-information :capital-account-year-to-date)
                           (empty-table-data? investor-information :capital-account-since-inception)
                           (not (:edit-mode? props)))]
    (when-not hide-section?
      [section/section "Investor information"
       (str "investor-information-"
            (some->> props
                     :report
                     :db/id))
       [:div
        [horizontal-table/table "Capital account (since inception)" capital-account-since-inception props]
        [horizontal-table/table "Capital account (year to date)" capital-account-year-to-date props]]])))

(defn fees-interest-expenses-section
  [{:keys [management-fees transaction-and-other-fees
           carried-interest fund-operating-expenses]
    :as   data} props]
  (let [hide-section? (and (empty-table-data? data :management-fees)
                           (empty-table-data? data :transaction-and-other-fees)
                           (empty-table-data? data :carried-interest)
                           (empty-table-data? data :fund-operating-expenses))
        table-config {:fixed-width? true}]
    (when-not hide-section?
      [section/section "GP fees, carried interest and fund operating expenses"
       (str "fees-interest-expenses-"
            (some->> props
                     :report
                     :db/id))
       [vertical-table/table "" management-fees (merge table-config props)]
       [vertical-table/table "" transaction-and-other-fees (merge table-config props)]
       [vertical-table/table "" carried-interest (merge table-config props)]
       [vertical-table/table "" fund-operating-expenses (merge table-config props)]])))

(defn report-view
  [{:keys [fund-ui-data] :as props}]
  (let [{:keys [fund-overview fund-status portfolio-information investor-information]} fund-ui-data]
    [:div
     [:div {:id :fund-overview}
      [:div
       [fund-overview-section fund-overview props]]]
     [:div {:id :fund-information}
      [:div
       [fund-status-section fund-status props]]]
     [:div {:id :portfolio-information}
      [:div
       [portfolio-information-section portfolio-information props]]]]))

(defn after-holdings-view
  [{:keys [fund-ui-data] :as props}]
  (let [{:keys [fund-overview fund-status portfolio-information investor-information]} fund-ui-data]
    [:div
     [:div {:id :investor-information}
      [:div
       [investor-information-section investor-information props]]]
     [:div {:id :fees-interest-expenses}
      [:div
       [fees-interest-expenses-section fund-status props]]]]))
